import { handleForbiddenError, handleForbiddenErrorText } from "@portal/helpers/handleForbiddenError";
import { IUseCreatePortfolio, ResponsePayload } from "./types";
import { RobotTextResources } from "@portal/assets/text/RobotTextResources";
import { IClientCreatePortfolio } from "@portal/types/api/IClientCreatePortfolio";
import { TextResources } from "@portal/assets/text/TextResources";

const useCreatePortfolio: IUseCreatePortfolio = () => {
  const submitCreatePortfolio = async (req: IClientCreatePortfolio) => {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(req),
    };

    const url = "/api/portfolio";
    const response = await fetch(url, requestOptions);
    const payload = { response, error: "" } as ResponsePayload;

    if (!response.ok) {
      const handledForbiddenError = await handleForbiddenError(response);
      if (handledForbiddenError) {
        payload.error = handledForbiddenError;
        return payload;
      }

      if (req.portfolioType === "IPS") {
        const text = await response.text();
        payload.error =
          (handleForbiddenErrorText(text) ?? response.status === 422)
            ? TextResources.IPS_CONFIRMATION_TEXT_ERROR_EXISTING_ACCOUNT
            : TextResources.IPS_CONFIRMATION_TEXT_ERROR_GENERIC;

        return payload;
      }

      payload.error =
        req.portfolioType === "ASK" ? RobotTextResources.primary.ASK_ERROR_GENERIC : TextResources.CREATE_ACCOUNT_ERROR_GENERIC;
    }

    return payload;
  };

  return {
    submitCreatePortfolio,
  };
};

export default useCreatePortfolio;
